export default "/images/ic_success.svg?7aef3491e0b6b66a65d4e9cb5a0c2b19";